import React from 'react'

const formatPrice = price => {
  const numeric = Number(price)
  return Number.isFinite(numeric) ? numeric.toFixed(2) : price
}

const Price = ({ price, currencySymbol, currencySymbolPlacement }) => {
  const formatted = formatPrice(price)

  if (currencySymbolPlacement === 'start') {
    return (
      <>
        {currencySymbol}
        {formatted}
      </>
    )
  }

  return (
    <>
      {formatted}
      {currencySymbol}
    </>
  )
}

export default Price
